import { connect } from 'react-redux';

import {
    DispatchPropsType,
    MapStateType,
} from '../organisms/bulkUrlShortenerForm';
import BulkURLShortenerForm from '../organisms/bulkUrlShortenerForm';
import { closeSideBar, getParams } from '../../../store/sidebar';
import { requestObject } from '../../../store/Object';
import { Instances } from '../../../constants';
import { makeSelectObjectsArray, requestObjects } from '../../../store/Objects';

const mapStateToProps = (state: any) => ({
    isEdit: getParams(state),
    viewData: makeSelectObjectsArray(Instances.bulkUrlShortenerList)(state) || {},
});

const mapDispatchToProps = {
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.bulkUrlUpload, undefined, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
    onClose: () => closeSideBar(),
    onEdit: (formData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.urlShortenerUpdate, { _method: 'PUT' }, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag)),
    onLoad: (filters?: any, SearchStr?: string) => requestObjects(Instances.bulkUrlShortenerList, {...filters, title: SearchStr}, { page: true, searchTerm: "title" })
};

export default connect<MapStateType, DispatchPropsType, unknown, any>(
    mapStateToProps,
    mapDispatchToProps
)(BulkURLShortenerForm);
